import Experience from "./app/experience";

new Experience(document.querySelector("canvas.webgl"));
